import { defineComponent, ref, onMounted, openBlock, createBlock, unref, normalizeClass, withCtx, createElementVNode, toDisplayString, createElementBlock, createTextVNode, createCommentVNode, createVNode, Fragment, renderList } from "vue";
import { CdrContainer, CdrLink, IconArrowRight } from "@rei/cedar";
import { expertAdviceCMSParser } from "../../util/contentstackHelpers.mjs";
const _hoisted_1 = {
  ref: "expertAdvice"
};
const _hoisted_2 = {
  class: "expert-advice__main-content"
};
const _hoisted_3 = {
  class: "expert-advice__top"
};
const _hoisted_4 = {
  class: "expert-advice__main-content_info"
};
const _hoisted_5 = {
  class: "expert-advice__title"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  class: "expert-advice__main-content_media"
};
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
  key: 0,
  class: "expert-advice__main-content_media-location"
};
const _hoisted_10 = {
  class: "expert-advice__footer"
};
const _hoisted_11 = {
  key: 0,
  class: "expert-advice-section"
};
const _hoisted_12 = {
  class: "advice-cards"
};
const _hoisted_13 = ["src", "alt"];
const _hoisted_14 = {
  class: "advice-card__title"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ExpertAdvice",
  props: {
    mainContent: {},
    moreContent: {},
    styleId: {},
    showXlBreakpoint: {
      type: Boolean
    }
  },
  emits: ["metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const htmlContent = ref("");
    onMounted(async () => {
      const response = await expertAdviceCMSParser(props.mainContent.faqs);
      htmlContent.value = response;
    });
    function handleArticleClick() {
      emit("metricsClick", {
        linkName: "secondary article click"
      });
    }
    function handleFeatureArticleClick() {
      emit("metricsClick", {
        linkName: "featured article click"
      });
    }
    function linkToExpertAdvice(href) {
      return `${href}?related-style-id=${props.styleId}`;
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(CdrContainer), {
        class: normalizeClass(["expert-advice", _ctx.showXlBreakpoint && "expert-advice--xl"])
      }, {
        default: withCtx(() => [createElementVNode("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [createElementVNode("div", _hoisted_3, [createElementVNode("div", _hoisted_4, [createElementVNode("h3", _hoisted_5, toDisplayString(_ctx.mainContent.title), 1), createElementVNode("div", {
          class: "expert-advice__main-content_text",
          innerHTML: htmlContent.value
        }, null, 8, _hoisted_6)]), createElementVNode("div", _hoisted_7, [createElementVNode("img", {
          src: _ctx.mainContent.imageSrc,
          alt: _ctx.mainContent.imageAltText,
          class: "main-image"
        }, null, 8, _hoisted_8), _ctx.mainContent.location ? (openBlock(), createElementBlock("div", _hoisted_9, [createTextVNode(toDisplayString(_ctx.mainContent.location) + " ", 1), _cache[2] || (_cache[2] = createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          class: "gnav-icon",
          "aria-hidden": "true"
        }, [createElementVNode("use", {
          "xlink:href": "#gnav-location-pin-stroke"
        })], -1))])) : createCommentVNode("", true)])]), createElementVNode("div", _hoisted_10, [createVNode(unref(CdrLink), {
          href: linkToExpertAdvice(_ctx.mainContent.moreInfo.link),
          onClick: _cache[0] || (_cache[0] = () => handleFeatureArticleClick())
        }, {
          default: withCtx(() => [createElementVNode("p", null, toDisplayString(_ctx.mainContent.moreInfo.text), 1), createVNode(unref(IconArrowRight))]),
          _: 1
        }, 8, ["href"])])]), _ctx.moreContent.length === 3 ? (openBlock(), createElementBlock("div", _hoisted_11, [_cache[3] || (_cache[3] = createElementVNode("h3", {
          class: "expert-advice-section__title"
        }, " More expert advice ", -1)), createElementVNode("div", _hoisted_12, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.moreContent, (item, index) => {
          return openBlock(), createElementBlock("div", {
            key: index,
            class: "advice-card"
          }, [createVNode(unref(CdrLink), {
            class: "advice-card__url",
            href: linkToExpertAdvice(item.link),
            onClick: _cache[1] || (_cache[1] = () => handleArticleClick())
          }, {
            default: withCtx(() => [createElementVNode("img", {
              src: item.imageSrc,
              alt: item.imageAltText,
              class: "advice-image"
            }, null, 8, _hoisted_13), createElementVNode("p", _hoisted_14, toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["href"])]);
        }), 128))])])) : createCommentVNode("", true)], 512)]),
        _: 1
      }, 8, ["class"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ExpertAdvice2.mjs.map
